// Re-import Theme as it's needed for baseCellStyles
import { MuiTableCell, styled, Theme } from '../../../base-components';
// Re-import baseCellStyles
import { baseCellStyles } from '../../base.styles';
import { ITableStickyColumn } from '../../table.interfaces';
import { shouldForwardProp } from '@mui/system';

// Define props to filter out for THIS component
const styledTableCellPropsToFilter: PropertyKey[] = [
    'alignment',
    'columnIndex',
    'stickyColumn',
    'rowStickyWidths',
    'isSelected',
];

// Keep the local shouldForwardProp logic
const customShouldForwardProp = (prop: PropertyKey) =>
    shouldForwardProp(prop) && !styledTableCellPropsToFilter.includes(prop);

// Define only the props needed and passed through
export const StyledTableCell = styled(MuiTableCell, {
    shouldForwardProp: customShouldForwardProp,
})<{
    theme: Theme;
    // Props passed TO this component, filtered by shouldForwardProp
    alignment?: string;
    stickyColumn?: ITableStickyColumn;
    rowStickyWidths?: Array<number>;
    columnIndex: number | undefined;
    isSelected?: boolean;
}>(({
    // Destructure all props needed for baseCellStyles and local styles
    theme,
    stickyColumn,
    columnIndex,
    rowStickyWidths,
    // alignment, // Keep alignment available if needed for baseCellStyles or future logic
    // isSelected // Keep isSelected available if needed for baseCellStyles or future logic
}) => {
    // Get base styles by calling baseCellStyles with correct arguments
    const baseStyles = baseCellStyles(
        theme,
        stickyColumn?.side,
        columnIndex,
        stickyColumn?.width,
        rowStickyWidths
    );

    return {
        ...baseStyles, // Spread the base styles
        // Add local styles
        textAlign: 'start',
    };
});
